import { useRef } from "react";
import useZipCodeCities from "shared/hooks/useZipCodeCities";
import {
  applyAcorisZipFieldChange,
  isCompleteAcorisZipInput,
  resolveForeignZipUi,
} from "./zipCode";

const useAcorisZipAddress = (zipCode) => {
  const lastCompleteZipRef = useRef(
    isCompleteAcorisZipInput(zipCode) ? String(zipCode).trim() : "",
  );
  const isForeignZip = resolveForeignZipUi(zipCode, lastCompleteZipRef.current);
  const { cities, loading: citiesLoading } = useZipCodeCities(
    isForeignZip ? "" : zipCode,
  );

  const changeZip = (rawValue) => {
    const result = applyAcorisZipFieldChange({
      lastCompleteZipCode: lastCompleteZipRef.current,
      rawValue,
    });
    lastCompleteZipRef.current = result.nextCompleteZipCode;
    return result;
  };

  return { isForeignZip, cities, citiesLoading, changeZip };
};

export default useAcorisZipAddress;
